import styles from './ResultsError.less';

import React, { Component } from 'react';

export default class ResultsError extends Component {

  render() {
    return (
      <div className={styles.root}>
        <p className={styles.heading}>
          Oops, looks like something went wrong&hellip;
        </p>
        <p className={styles.paragraph}>
          Try refreshing the page, or modifying your search criteria.
        </p>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/ResultsError/ResultsError.js
 **/